import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import EmailTemplateUploadForm from './EmailTemplateUploadForm';
import EmailTemplateUploadFormService from '../services/EmailTemplateUploadFormService';

class EmailTemplateUploadFormContainer extends React.Component {
  static propTypes = {
    selectedLocales: PropTypes.array,
    emailTemplateId: PropTypes.string,
  };

  static defaultProps = {
    selectedLocales: [],
    emailTemplateId: null,
  };

  componentDidMount() {
    EmailTemplateUploadFormService.init();
  }

  render() {
    return (
      <EmailTemplateUploadForm
        onSubmit={EmailTemplateUploadFormService.handleSubmit}
        onChange={EmailTemplateUploadFormService.form.setValue}
        values={EmailTemplateUploadFormService.form.getValues()}
        errors={EmailTemplateUploadFormService.form.errors}
        selectedLocales={this.props.selectedLocales}
        emailTemplateId={this.props.emailTemplateId}
      />
    );
  }
}

export default observer(EmailTemplateUploadFormContainer);
